module.exports = __webpack_public_path__ + "static/media/yl_logo_icon.6832ed06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yl_logo_icon.svg
// module id = 67
// module chunks = 0